var map = {
	"./en/analytics.json": 2182,
	"./en/approvals.json": 5111,
	"./en/attendance.json": 4715,
	"./en/auth.json": 2723,
	"./en/common.json": 4053,
	"./en/dashboard.json": 3394,
	"./en/inbox.json": 7495,
	"./en/payroll.json": 292,
	"./en/register.json": 8644,
	"./en/settings.json": 6841,
	"./en/shared.json": 7922,
	"./en/users.json": 1035,
	"./hi/analytics.json": 6851,
	"./hi/approvals.json": 7203,
	"./hi/attendance.json": 2090,
	"./hi/auth.json": 4021,
	"./hi/common.json": 2405,
	"./hi/dashboard.json": 2125,
	"./hi/inbox.json": 1433,
	"./hi/payroll.json": 6961,
	"./hi/register.json": 1045,
	"./hi/settings.json": 959,
	"./hi/shared.json": 5736,
	"./hi/users.json": 5143,
	"./id/analytics.json": 1430,
	"./id/approvals.json": 9866,
	"./id/attendance.json": 11,
	"./id/auth.json": 2922,
	"./id/common.json": 3389,
	"./id/dashboard.json": 6015,
	"./id/inbox.json": 802,
	"./id/payroll.json": 8944,
	"./id/register.json": 5345,
	"./id/settings.json": 7196,
	"./id/shared.json": 8703,
	"./id/users.json": 814,
	"./ms/analytics.json": 6636,
	"./ms/approvals.json": 5658,
	"./ms/attendance.json": 7184,
	"./ms/auth.json": 1663,
	"./ms/common.json": 5425,
	"./ms/dashboard.json": 8960,
	"./ms/inbox.json": 3633,
	"./ms/payroll.json": 8839,
	"./ms/register.json": 4457,
	"./ms/settings.json": 1727,
	"./ms/shared.json": 473,
	"./ms/users.json": 7713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7035;